<div class="base">
    <div class="contenedor">
        <div class="contenido">
            <div class="loader">
            </div>
        </div>
    </div>
</div>